import { BadgeComponents } from "@root/components/collection/data";

const variantUSP = [
    {
        key: "Waterproof",
        image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/Waterproof-Icon.png",
        text: {
            supreme: "Yes",
            elite: "Yes",
            // proguard: "Yes",
        },
    },
    {
        key: "UV Resistant",
        image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/UV-Resistant-Icon.svg",
        text: {
            supreme: "High",
            // elite: "Medium",
            proguard: "High",
        },
    },
    {
        key: "Warranty",
        image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/Warranty-Icon.png",
        text: {
            supreme: "Lifetime",
            elite: "10 Years",
            proguard: "5 Years",
        },
    },
    // {
    //     key: "Weight",
    //     image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/Weight-Icon.png",
    //     text: {
    //         supreme: "18 Oz",
    //         elite: "8 Oz",
    //         proguard: "12 Oz",
    //     },
    // },
    {
        key: "Fabric",
        image: "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/Fabric-Icon.png",
        text: {
            supreme: "Patent pending<br>SEAL-TEC fabric",
            elite: "Strong Double<br>Sided PVC",
            proguard: "100% Polyester",
        },
    }
];

const fabricCardsContent = {
    supreme: {
        description: "All Weather",
        badge: BadgeComponents.lifetimeNew,
        isBestSeller: true,
        warranty: "Lifetime Warranty"
    },
    elite: {
        description: "Rainy Climate",
        badge: BadgeComponents.tenYearNew,
        isBestSeller: false,
        warranty: "10 Year Warranty"
    },
    proguard: {
        description: "Sunny Weather",
        badge: BadgeComponents.fiveYearNew,
        isBestSeller: false,
        warranty: "5 Year Warranty"
    },
}

const variantText = {
    supreme: [
        { key: "material", value: "Patent pending SEAL-TEC fabric" },
        { key: "feature", value: "Diamond Finish exterior, Soft Finish interior, Handles for easy use, Air Vents, Rot Proof Seams, Draw Cord" },
        { key: "ideal for", value: "Extreme Weather" },
    ],
    elite: [
        { key: "material", value: "Strong Double Sided PVC" },
        { key: "feature", value: "Handles for easy use, Air Vents, Rot Proof Seams, Draw Cord" },
        { key: "ideal for", value: "Rainy Climates" },
    ],
    proguard: [
        { key: "material", value: "100% Polyester Fabric" },
        { key: "feature", value: "Handles for easy use, Air Vents, Rot Proof Seams, Draw Cord" },
        { key: "ideal for", value: "Sunny Weather" },
    ],
};

const personalizationOptions = {
    text: "Print Text",
    logo: "Print LOGO",
};

const cartPatioProperties = [
    {
        key: "personalization",
        value: "Personalize Type",
    },
    {
        key: "logo",
        value: "Logo",
    },
    {
        key: "personalizationSide",
        value: "Print Sides",
    },
    {
        key: "personalizationColor",
        value: "Color",
    },
    {
        key: "personalizationFont",
        value: "Font",
    },
];

const patioData = {
    variantUSP, variantText, personalizationOptions, cartPatioProperties, fabricCardsContent,
};

export default patioData;
